module.exports = __webpack_public_path__ + "img/yj_3.f634fc68.png";